package com.example.hukakmp.ui

import androidx.compose.foundation.Image
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.size
import androidx.compose.foundation.layout.width
import androidx.compose.foundation.shape.CircleShape
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.clip
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.layout.ContentScale
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.unit.dp
import androidx.compose.ui.unit.sp
import com.example.hukakmp.resources.Res
import com.example.hukakmp.resources.huka_logo
import org.jetbrains.compose.resources.painterResource

/**
 * Marca oficial Huka compartida entre Web, Android e iOS.
 */
@Composable
fun HukaLogoMark(
    modifier: Modifier = Modifier.size(52.dp),
    tint: Color = MaterialTheme.colorScheme.primary,
) {
    Image(
        painter = painterResource(Res.drawable.huka_logo),
        contentDescription = "Logo Huka",
        modifier = modifier.clip(CircleShape),
        contentScale = ContentScale.Crop,
    )
}

@Composable
fun HukaWordmark(
    modifier: Modifier = Modifier,
    lightContent: Boolean = false,
    showSubtitle: Boolean = true,
) {
    val mainColor = if (lightContent) Color.White else MaterialTheme.colorScheme.primary
    val secondaryColor = if (lightContent) {
        Color.White.copy(alpha = 0.78f)
    } else {
        MaterialTheme.colorScheme.onSurfaceVariant
    }

    Row(
        modifier = modifier,
        verticalAlignment = Alignment.CenterVertically,
        horizontalArrangement = Arrangement.Start,
    ) {
        HukaLogoMark()
        Spacer(Modifier.width(10.dp))
        Column {
            Text(
                text = "HUKA",
                color = mainColor,
                fontSize = 24.sp,
                fontWeight = FontWeight.Black,
                letterSpacing = 2.sp,
            )
            if (showSubtitle) {
                Text(
                    text = "Pesca recreativa · Ciencia ciudadana",
                    color = secondaryColor,
                    style = MaterialTheme.typography.labelSmall,
                )
            }
        }
    }
}
